import { exists } from "../../_helper/util.helper";

export class MiscModel {

  //text in misc places
  public title: string = 'Amplify';
  public memberText: string = 'Member';

  //media management
  public adminMemberPhotos: boolean = false;
  public adminOfficePhotos: boolean = false;

  //metadata management
  public metadataFields: string[] = [];
  public excludeMetadataFields: string[] = [];

  //toolbar junk
  public showToolbarBorder: boolean = false;
  public toolbarBorderColor: string = null;
  public toolbarText: string = null;
  public toolbarSubtext: string = null;

  constructor(model?: Partial<MiscModel>) {
    if (model?.title) this.title = model.title;
    if (model?.memberText) this.memberText = model.memberText[0].toUpperCase() + model.memberText.substring(1);

    if (exists(model?.adminMemberPhotos)) this.adminMemberPhotos = model.adminMemberPhotos;
    if (exists(model?.adminOfficePhotos)) this.adminOfficePhotos = model.adminOfficePhotos;

    if (model?.metadataFields?.length) this.metadataFields = [ ...model.metadataFields ];
    if (model?.excludeMetadataFields?.length) this.excludeMetadataFields = [ ...model.excludeMetadataFields ];

    //toolbar border
    if (exists(model?.showToolbarBorder)) this.showToolbarBorder = model.showToolbarBorder;
    else if (exists(model?.['showOrangeToolbar'])) this.showToolbarBorder = model['showOrangeToolbar'];

    //toolbar border color
    if (exists(model?.toolbarBorderColor)) this.toolbarBorderColor = model.toolbarBorderColor;
    else if (exists(model?.['showOrangeToolbar'])) this.toolbarBorderColor = '#FF8000';

    //toolbar text
    if (exists(model?.toolbarText)) this.toolbarText = model.toolbarText;
    else if (exists(model?.['orangeToolbarText'])) this.toolbarText = model['orangeToolbarText'];

    //toolbar subtext
    if (exists(model?.toolbarSubtext)) this.toolbarSubtext = model.toolbarSubtext;
    else if (exists(model?.['orangeToolbarSubtext'])) this.toolbarSubtext = model['orangeToolbarSubtext'];
  }
}
